module.exports = __webpack_public_path__ + "img/snel-verkocht.d38c2aaac149fdb5f77a96e671bdefe1.svg";